import Page from "@app/components/pageTypes/Page/Page"
import { useSelector } from "@tecreation/js-state-react"
import { useNavigate } from "react-router"

export default function MaintenancePage() {
	const lang = useSelector("core.languageCode")
	const navigate = useNavigate()

	const translations = {
		de: {
			title: "Wir sind bald wieder für dich da!",
			description: "Unser Shop befindet sich derzeit in Wartung. Wir arbeiten daran, dir bald wieder das gewohnte Einkaufserlebnis bieten zu können.",
			ticketInfo: "Du kannst weiterhin Tickets buchen. Klicke einfach auf den Button, um zur Ticketbuchung zu gelangen.",
			button: "Tickets buchen",
		},
		fr: {
			title: "Nous serons bientôt de retour !",
			description: "Notre boutique est actuellement en maintenance. Nous travaillons pour vous permettre de retrouver bientôt votre expérience habituelle.",
			ticketInfo: "La réservation de billets reste possible. Cliquez sur le bouton ci-dessous pour accéder à la billetterie.",
			button: "Réserver des billets",
		},
		en: {
			title: "We'll be back soon!",
			description: "Our shop is currently undergoing maintenance. We're working to restore your usual shopping experience as soon as possible.",
			ticketInfo: "You can still book tickets. Simply click the button below to access ticket booking.",
			button: "Book tickets",
		},
	}

	const normalizedLang = String(lang || "de")
		.slice(0, 2)
		.toLowerCase()
	const t = translations[normalizedLang] || translations.de

	return (
		<Page className="px-4">
			<div className="flex flex-column h-100 text-center" style={{ margin: "0 auto", maxWidth: "600px", padding: "32px 0" }}>
				<svg
					version="1.1"
					id="Ebene_1"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
					x="0px"
					y="0px"
					viewBox="0 0 252.5 332.8"
					xml:space="preserve"
					style={{
						width: "170px",
						height: "auto",
						maxHeight: "300px",
						display: "block",
						margin: "0 auto",
					}}
				>
					<style>{`
	.st0 { fill: #002751; }
	.st1 { fill: #FEDFB3; }
	.st2 { fill: #002751; }
	.st3 { fill: #DCC29D; }
	.st4 { fill: #4E95C1; }
	.st5 { fill: none; }
	.st6 { fill: #F1C28E; }
`}</style>

					<path
						class="st1"
						d="M174.6,186.5c-1.2-0.3-6.1-6.3-6.4-8.5c-1.6-0.4-7.8-4.8-9.2-6.8c-2,0-10-2.4-11.9-4c-1.3,0.2-8.8-1-8.8-1
	l-14.3-1.5c0,0-8.4,1-10.7,0c-1.5,0.8-11.1,2.1-13.1,1.3c-0.8,0.8-8.2,3.6-10.4,3.1c-1.1,0.9-7.2,4.4-8.8,4.9
	c-0.2,1.1-3.8,6.8-5.6,7.7c0.7,0.4,0.6,1.6-0.3,3.2c-0.9,1.7-0.3,4.9,1,3.9c0,0,1.3,4.6,3.3,6.4c1.5,1.3,4,3.2,5.2,3.3
	c2.6,0.3,8.6-2.3,10.9-2.1c1.6,0.2,3,3.2,4,3.7c1,0.4,1.3,0.1,2.3-0.2c2,0,11.1-0.7,12.4-0.8c1.4-0.1,3.2,0.8,4.6,0.1
	c0.3-0.2,1.5-0.9,1.8-1c2.7-1,6.8-1.4,9.9,0.3c3,1.6,14.1,3,16.1,3.4c2.1,0.4,2.9,0.5,3.3,0.1c0.7-0.7-2.8-2.5-0.2-2.8
	c1.5-0.2,13.4,0.1,15.2,0.2c3.1,0.1,6.6-4.5,8.7-4.6C175.3,193.8,173.5,189,174.6,186.5z"
					/>
					<path
						class="st2"
						d="M168.7,179.1c-0.2-0.4-0.4-0.8-0.4-1.2l0,0c0,0,0-0.1-0.1-0.1l0,0c-1.6-0.4-7.7-4.8-9.1-6.7l0,0L159,171
	c-2.1,0-10-2.4-11.8-3.9l0,0h-0.1l0,0c-0.1,0-0.2,0-0.4,0c-2,0-8.3-1-8.3-1l-14.3-1.5c0,0-3.8,0.5-6.9,0.5c-1.8,0-3.1-0.1-3.8-0.4
	l0,0h-0.1l0,0l0,0l0,0l0,0c-1.2,0.6-7.2,1.5-10.7,1.5c-1.1,0-1.8-0.1-2.2-0.2c-0.1,0-0.1,0-0.2,0c-0.6,0.6-6.8,3.1-9.6,3.1
	c-0.2,0-0.5,0-0.6-0.1l0,0h-0.1l0,0c-1.1,0.9-7.2,4.4-8.8,4.9l0,0c0,0-0.1,0-0.1,0.1l0,0c-0.1,0.6-1.6,3.1-3.1,5.1H62.5
	c13.5,20.9,37,34.7,63.7,34.7s50.2-13.8,63.7-34.7L168.7,179.1L168.7,179.1z M174,186.3c-5,0.6-27.4,10-30,11.5
	c-1.1,0-2.6,0.1-4.1,0.2c2.1-1.1,6.6-4.6,11.7-8.5c6.8-5.2,14.4-11.1,16.4-11.3c0.1,0.3,0.2,0.6,0.3,1
	C169.5,181.4,172.5,185.3,174,186.3z M167.6,177.9c-2.6,0.8-9.5,6.1-16.2,11.3c-5.7,4.4-11,8.5-12.4,8.9c-1.4,0.1-2.8,0.2-4.1,0.3
	c2.9-1.8,9.1-9.5,14.7-16.3c4.1-5.1,8.4-10.4,9.4-10.7C160.3,173.2,165.5,177,167.6,177.9z M84.5,198.3c-1.1-0.1-3.3-1.7-5.1-3.3
	c-1.6-1.4-2.8-5-3.1-6c0.6,0.2,1.8,0.8,3.4,1.5c3.5,1.5,8.6,3.8,13.9,5.9c-1,0.2-2.2,0.5-3.4,0.8C88.1,197.8,85.9,198.4,84.5,198.3z
	 M95.5,196.2c-0.3,0-0.8,0-1.2,0.1c-5.5-2.1-10.9-4.5-14.4-6.1c-2.1-0.9-3.4-1.5-3.7-1.6l0,0l0,0l0,0h-0.1l0,0
	c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.2-0.4-0.3c-0.4-0.7-0.5-2.5,0.1-3.5c0.7-1.3,0.9-2.3,0.6-3c1,0.5,3.3,2,6,3.7
	c6.9,4.6,17.4,11.5,24.1,12.7l0,0c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0-0.2-0.1-0.2c-6.6-1.3-17-8.1-23.9-12.7c-3.3-2.2-5.3-3.5-6.2-3.8
	c0.7-0.5,1.6-1.4,2.4-2.5c1.4-1.8,2.7-4.1,2.9-4.9c0.6,0.2,2.5,2.2,4.7,4.6c5.2,5.5,13.9,14.8,21.7,17.9c0,0,0,0,0.1,0
	s0.1,0,0.1-0.1s0-0.2-0.1-0.2c-7.7-3.1-16.4-12.3-21.6-17.9c-2.4-2.6-3.8-4.1-4.6-4.5c2-0.8,7.2-3.8,8.4-4.7c0.5,0.4,2.3,3,4.5,6.2
	c5.4,7.8,14.3,20.8,19.5,23.4c-1.6,0.1-6.7,0.5-9.8,0.7c-1.9-0.5-4.2-1.2-6.7-2.1l0,0C96.8,196.8,96.1,196.3,95.5,196.2z
	 M101.8,199.7c-0.2,0.1-0.5,0.1-0.6,0.2c-0.6,0.2-0.9,0.3-1.6,0c-0.4-0.2-0.8-0.8-1.3-1.4c-0.1-0.2-0.3-0.4-0.5-0.6
	c1.9,0.7,3.7,1.3,5.3,1.7C102.5,199.6,102.1,199.6,101.8,199.7C101.8,199.6,101.8,199.6,101.8,199.7z M114.6,198.9
	c-5-1.9-14.4-15.5-20-23.6c-2.3-3.3-3.6-5.2-4.3-6c0.1,0,0.1,0,0.2,0c2.6,0,8.5-2.2,9.7-3.1c0.4,0.5,1.6,3.5,3,6.9
	c3.5,8.7,9.2,22.9,13.1,26c-0.1,0-0.2,0-0.3,0C115.5,199,115,198.9,114.6,198.9z M117.5,199.3c-0.2,0-0.3,0-0.5,0
	c-3.8-1.7-9.9-17-13.6-26.2c-1.5-3.8-2.4-5.9-2.9-6.8c0.5,0.1,1.1,0.1,1.9,0.1c3.6,0,9.3-0.9,10.7-1.5c0.2,0.6,0.5,3.4,0.9,6.5
	c1.2,9.2,3.1,24.5,5,27.3c-0.2,0.1-0.4,0.2-0.5,0.3C118.3,199.2,118,199.3,117.5,199.3z M119.4,198.6c-1.9-2.6-3.9-18.5-5-27.1
	c-0.5-4.1-0.7-5.8-0.9-6.4c0.8,0.2,1.9,0.4,3.6,0.4c3.2,0,6.9-0.5,6.9-0.5l14,1.4c-1.2,1.5-4.3,9.2-8.3,19.8
	c-2.1,5.3-3.8,9.9-4.5,11.1c-1.6,0-3.3,0.3-4.8,0.9C120.3,198.1,119.9,198.3,119.4,198.6z M125.6,197.1c0.7-1.4,2.4-5.9,4.4-10.9
	c3.2-8.1,7.5-19.3,8.4-19.8c0.6,0.1,6.4,1,8.3,1l0,0c-0.6,0.8-2,3.5-5.3,9.7c-4.3,8.1-10.2,19.3-12,20.7
	C128.3,197.4,127,197.1,125.6,197.1z M129.7,197.9c2-1.8,7.5-12.2,12-20.7c2.5-4.8,4.9-9.3,5.4-9.8c1.8,1.5,8.6,3.6,11.3,3.9
	c-1.4,1-4.4,4.7-9.1,10.5c-5.8,7.2-13,16.1-15.3,16.6c-1,0.1-1.9,0.2-2.4,0.3c-0.4-0.1-0.8-0.3-1-0.4
	C130.3,198.1,130,198,129.7,197.9z M149.8,201.8c-0.1,0.1-0.4,0.2-0.7,0.2c-0.5,0-1.3-0.1-2.4-0.4c-0.4-0.1-1.3-0.2-2.4-0.4
	c-3.2-0.5-8.7-1.3-11.9-2.3c2.7-0.3,8.7-0.8,11.8-0.8l0,0c0.7,0,1.6,0.3,2.5,0.5c0.7,0.2,1.5,0.4,2.2,0.5c-0.1,0.1-0.2,0.2-0.2,0.3
	c-0.1,0.4,0.2,0.8,0.6,1.3C149.7,201.2,150,201.6,149.8,201.8z M165,199.2L165,199.2h-0.1c-1.4-0.1-8.8-0.2-12.8-0.2
	c-1.3,0-2.1,0-2.4,0.1c-0.7,0-1.6-0.2-2.5-0.5c4.2-0.9,20.4-3.5,25.4-3.6c-0.7,0.4-1.6,1-2.5,1.7C168.4,197.8,166.6,199.2,165,199.2
	z M173.5,194.6c-3.5-0.3-23.8,3-27,3.7l0,0c-0.7-0.2-1.3-0.4-1.9-0.4c4.1-2.2,25.9-11.1,29.7-11.3c-0.4,1.1-0.3,2.6-0.2,4
	C174.2,192.4,174.3,194,173.5,194.6z"
					/>
					<path
						class="st3"
						d="M130.4,198.7c-1.4-0.7-3.1-1.1-4.9-1.1c-1.7,0-3.4,0.3-4.9,0.9c-0.1,0-0.6,0.4-1.1,0.6
	c-0.3,0.2-0.6,0.3-0.7,0.4c-0.4,0.2-0.8,0.3-1.3,0.3s-1.1-0.1-1.6-0.2c-0.6-0.1-1.2-0.2-1.7-0.2c-1.4,0.1-10.4,0.8-12.3,0.8
	c-0.2,0.1-0.4,0.1-0.6,0.2c-0.3,0.1-0.6,0.2-0.9,0.2s-0.5-0.1-0.9-0.2c-0.5-0.2-0.9-0.8-1.5-1.5c-0.8-1-1.6-2.1-2.5-2.1
	c-1.1-0.1-3,0.4-5.1,1c-1.4,0.4-2.9,0.8-4.1,1c2.5,0.3,7.5,1.1,9.9,1.7c2.2,0.6,7,2.5,8.3,3.9l0,0c1,1,10.2,0.1,14.1-2.1
	c1.3-0.7,1.9-1.5,1.7-2.3c0-0.1,0-0.2,0.1-0.2s0.2,0,0.2,0.1c0.2,0.9-0.4,1.8-1.8,2.6c-2.8,1.5-8.4,2.5-11.8,2.5
	c-0.7,0-1.3,0-1.8-0.1c1.5,1.2,5.1,3.4,8.9,3.9l0,0l0,0c1.6,0.4,5.7-1.9,7.5-4.5c0.7-1,1.3-2.5,0.3-3.8c-0.1-0.1,0-0.2,0-0.2
	c0.1-0.1,0.2,0,0.2,0c0.9,1.2,0.8,2.6-0.3,4.2c-1.5,2.3-5,4.5-7.1,4.7c2,1,4.5,1.7,6.5,1.7c0.2,0,0.5,0,0.7,0l0,0l0,0
	c0.8,0,1.8-1.2,2.5-2.8c0.7-1.7,1.1-4.2-0.2-5.5c-0.1-0.1-0.1-0.2,0-0.2c0.1-0.1,0.2-0.1,0.2,0c1.4,1.5,1,4.1,0.2,5.9
	c-0.5,1.2-1.3,2.4-2.1,2.8c0.7,0.1,1.4,0.2,2.1,0.2c3.4,0,6-1.6,7.4-2.5c0.1-0.1,0.2-0.1,0.3-0.2c-1.1-0.2-2.4-1.2-4.2-2.5l-0.4-0.3
	c-0.1-0.1-0.1-0.2,0-0.2s0.2-0.1,0.2,0l0.4,0.3c2,1.5,3.5,2.6,4.5,2.5l0,0c1.1,0,3.3-2.1,4.7-3.3c0.3-0.2,0.5-0.5,0.7-0.6
	c-0.4,0.1-0.8,0.1-1.3,0.1c-2,0-4.9-0.6-6.3-1.4c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.2-0.1c2,1.2,6.8,1.8,8,1.1l0,0l0,0
	c0.4-0.2,0.9-0.5,1.3-0.8c0.8-0.5,1.8-1.2,2.8-1.4C138.9,200.9,132.6,199.8,130.4,198.7z"
					/>
					<path
						class="st4"
						d="M121.4,177.6L121.4,177.6c1.1-3.2,4.6-8.4,4.6-8.4c1.1-1.3,1.1-2.7,1.2-3.9c0-0.2,0-0.5,0.1-0.7l0,0
	c0.6-1.3,3.9-15.5,3.6-20.6h0.1c0.3,5.3-3,19.3-3.6,20.7c0,0.2,0,0.4-0.1,0.7c-0.1,1.2-0.2,2.6-1.3,3.9
	C126,169.2,122.6,174.4,121.4,177.6z"
					/>
					<path
						class="st5"
						d="M112.1,115c1-1.2,3.7-3.3,5.1-4.4l1.1-0.9c0.2-0.3,2.6-3.9,3-4.2c1.4-1.1,3-3.9,3.3-4c0,0,2.2-1,2.6-1.4
	c0.1-0.1,0.8-0.5,0.8-0.5c0.6-0.5,1-0.8,1.2-0.8c1.2,2-2.7,2.5-2.8,2.6c0.2-0.1,3.7-1.1,4.5-1.4c0.8,0.1,1.9-0.2,2.6-0.2
	s0.8,0.7,0.1,0.9s-2,0.5-2.5,0.5c-0.1,0-1.8,0.8-2.1,0.9c0.2,0,3,0.2,3.1,0.2s2.5,0.4,3.2,0.5s0.6,1.1-0.1,1.1s-2.8-0.3-3.1-0.3
	c0,0-1.1,0-2.7,0c0.9,0.2,2.7,0.4,3,0.5c0.2,0.1,2.2,0.5,2.7,0.6s0.4,0.9-0.2,0.9s-1.4-0.1-1.9-0.2s-2.6-0.2-3.6-0.2
	c0,0,1.1,0.2,2.1,0.4c0.9,0.2,1.2,0,1.7,0.1c0.4,0.1,0.5,0.6,0.2,0.8c-0.3,0.1-1.9,0.4-2.3,0.4s-1.3-0.5-2.4-0.3
	c-1,0.5-2.7,0.5-3.5,0.5c-0.1,0.1-1,1.7-1.4,2.5l-1.3,2c-1,2.1-2.9,5.5-3.4,6.1"
					/>
					<path
						class="st6"
						d="M147.2,119c0,0-0.6-2.7-1.2-4.6c-0.6-1.9-1.8-6.6-2.3-8.6c-0.8-3.4-1.3-6.3-3.1-10c-0.9-2-2.8-2.2-4.2-2.7
	c-0.6-0.2-1.3-0.5-1.9-0.8c-1.7-1-2.5-1.9-2.4-2.6c0.3-1.7,1.1-3.9,0.9-5.4c0.3-0.5,0.4-0.9,0.3-1.1c0,0-0.5-0.4-0.9-1.3
	c-0.6-1.4-0.3-3.1-1.4-3.8c-0.5-0.3-0.7-2.4-1.6-2.5c-0.8-0.2-1.6-1.3-3.2-0.8c-0.5,0.1-1.3-0.1-1.6,0c-0.6,0.2-2.2,1-2.2,3.6
	c0,1,0,1.7,0.8,3.4c0.5,2.4,2.7,4.5,2.9,4.6c0,0.6-0.5,1.2-0.6,2.3c-1,1.8-2.6,4-5.8,4c-1.4,0.3-3.4,1.1-4.4,2.4
	c-0.9,1.1-1.3,2.8-1.6,4.5c-0.3,2.6-0.7,4.5-1.4,6.2c-0.2,0.5-0.3,0.9-0.5,1.4c-0.4,1.2-0.8,2.2-1.1,3.4c-0.4,1.7-0.7,3.7-1,5.3
	c0,0.1-0.1,1.5,0.1,2.2c0.1,0.2,0.1,0.4,0.2,0.7c0.2,0.9,0.5,2.2,1.1,2.7c0.3,0.3,0.7,0.4,1.1,0.4c1,0,2-0.9,2-0.9
	c0.1-0.1,3.3-1.8,4-2.7c0.1-0.2,0.3-0.3,0.4-0.5c0.1-0.1,0.1-0.1,0.2-0.2c0.1,1.5,0.3,2.3,0.4,3c0.2,0.9,0.3,1.7,0.3,3.6
	c0,1.2-0.3,2.3-0.7,3.7c-0.6,2.3-1.4,5.3-1.7,11c-0.5,8.8,0.5,15,2.4,23.3c-0.2,0.3-0.4,0.7-0.7,1.2c-0.7,1.2-1.6,2.8-2.1,4.1
	c-1.2,2.2-2.7,6.4-3.2,11.4c-0.4,4-0.7,5.2-1.1,6.8c-0.1,0.5-0.2,1-0.4,1.8c0,0.9-2.8,5.2-4.7,7.2c-0.2,0.3-0.6,0.5-0.9,0.7
	c-0.2,0.1-0.3,0.2-0.4,0.3c-0.3,0.4-0.3,0.9-0.3,1c0,0,0,0.1-0.1,0.1c-0.5,0.4-0.4,0.9-0.4,1.2c0,0-0.8,0.8-0.2,1.4l0.2,0.2
	c-0.2,0.4-0.2,0.9,0.1,1.1c0.2,0.1,0.5,0.2,0.6,0.3c0,0.1,0.1,0.3,0.5,0.6c0.1,0.1,0.3,0.1,0.5,0.1c0.8,0,1.7-0.8,1.9-1
	c0.2-0.1,0.9-0.4,1.7-1.1c0.7-0.6,0.9-1.2,1.3-1.9c0.2-0.4,0.4-0.8,0.6-1.2c0.9-1.3,1.6-1.9,2.2-2.3c0.5-0.3,0.9-0.6,1.2-1.3
	s0.4-1.6,0.5-2.5c0-0.5,0.1-0.9,0.1-1.2c0.4-1.9,1.1-3.4,2-5.3c0.7-1.6,2.7-6.4,2.7-6.5c-0.3,1.8-0.5,4.7-0.2,8.9
	c0.3,4.6-1.4,7.5-1.7,8.7c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.2-0.1,0.4-0.1,0.7c-0.2,0.7-0.3,1.4,0.2,2.2c0.6,0.9,1.3,1.1,2,1.2
	c0.3,0.1,0.5,0.1,0.8,0.2c1,0.4,1.5,1.1,2.1,2c0.2,0.3,0.4,0.6,0.6,0.9c0.3,0.4,0.6,0.6,0.9,0.8c0.1,0.1,0.2,0.1,0.3,0.2l0.1,0.1
	c0.3,0.5,0.6,1,1,1.1c0.6,0.2,1.1,0.4,1.4,0.4c0.6,0,0.9-0.3,1.1-0.6c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.2-0.1,0.4-0.3
	c0.3-0.3,0.1-0.6,0-0.9c0-0.1,0-0.1,0-0.2c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.4-0.1-0.7-0.2-0.9c0-0.1,0-0.3,0-0.3c0-0.4-0.6-0.9-0.7-1
	c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.4-0.2-0.6c-0.2-0.3-0.6-0.6-0.9-0.8c-0.1-0.1-0.2-0.2-0.3-0.2c-0.6-0.5-1.1-1-1.4-1.5
	c-0.2-0.2-0.3-0.4-0.4-0.5c-0.4-0.4-2-3.1-2.2-3.7c-0.2-0.7,1.4-3.7,1.9-5.2c0.6-2.3,1.4-4.3,2.3-6.6c0.2-0.4,0.3-0.8,0.5-1.2
	c0.5-1.2,0.9-2.8,1.4-4.4c0.6-2.1,1.1-4,1.6-4.7c0.9-1.2,1.6-2.9,2.1-5c0.2-0.4,0.5-1,1-1.9c2.3-4,7.2-12.2,8.2-21.7
	c0.1-1.1,0.4-3.3,0.5-4.4c0.2-0.9,0.3-2.9,0.2-3.8C145.9,131.1,148,121.9,147.2,119z M118.3,109.6l-1.3,1c0,0,1.1-3.2,1.4-5.9
	c0.1,1.1-0.1,2.3,0,3.2c0.1,0.6,0.3,0.9,0.2,1.2L118.3,109.6z M141,122.5c-0.1,1-0.4,4.2-0.4,4.2c-0.1-1.3-1.9-7.5-2.8-9.3
	c-0.3-1.8-0.3-8.5-0.3-8.5s1.4,4.5,3.9,9.1C141.8,118.6,141.2,119.9,141,122.5z"
					/>
					<path
						class="st2"
						d="M134.5,108c-0.1,0-0.1,0.1-0.1,0.2s0,0.2-0.1,0.3c-0.1,0.1-0.3,0.1-0.4,0c-0.1,0-0.1-0.1-0.1-0.1
	c0-0.1-0.1-0.2-0.2-0.2s-0.2,0.1-0.2,0.2c0,0.2,0.1,0.3,0.3,0.4c0.1,0,0.2,0.1,0.3,0.1s0.3,0,0.4-0.1c0.1-0.1,0.3-0.3,0.2-0.6
	C134.7,108.1,134.6,108,134.5,108z"
					/>
					<g>
						<path
							class="st2"
							d="M129.7,84.6c-0.2,0-1.1,0.2-1.2,0.2h-0.1v0.1c0,0-0.1,0.1-0.2,0.2c-0.1,0-0.3,0-0.4-0.1h-0.1l-0.8,0.4
		c-0.1,0-0.1,0.1-0.1,0.2s0.1,0.1,0.1,0.1s0,0,0.1,0l0.7-0.3c0.1,0,0.4,0.1,0.6,0c0.2-0.1,0.3-0.2,0.4-0.3c0.3-0.1,0.9-0.2,1.1-0.2
		c0.1,0,0.2-0.1,0.2-0.2S129.8,84.6,129.7,84.6z"
						/>
						<path
							class="st2"
							d="M128.9,85.4c-0.2,0.2-0.8,0.3-1.2,0.2c-0.1,0-0.2,0-0.2,0.1s0,0.2,0.1,0.2s0.3,0.1,0.4,0.1
		c0.4,0,0.9-0.2,1.1-0.3c0.1-0.1,0.1-0.2,0-0.2C129,85.4,128.9,85.4,128.9,85.4z"
						/>
						<path
							class="st2"
							d="M124.9,79.6c0.6,0.2,1,0.6,1.2,1.2c0.3,0.7,0.2,1.4,0.2,2c0,0.5-0.1,0.9,0.2,1.1c0.1,0.1,0.2,0.1,0.4,0.1h0.1
		c0.1,0,0.1-0.1,0.1-0.2s-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.1-0.4-0.1-0.8c0-0.6,0.1-1.3-0.2-2.1
		c-0.3-0.7-0.8-1.2-1.4-1.4c-0.6-0.2-1.3-0.1-1.8,0.2c-0.1,0-0.1,0.1-0.1,0.2s0.1,0.1,0.2,0.1C123.9,79.5,124.4,79.5,124.9,79.6z"
						/>
						<path
							class="st2"
							d="M127.9,83.6c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0.1,0h0.1c0.1,0.1,0.2,0,0.2,0c0.1-0.1,0-0.2,0-0.2
		c-0.1-0.1-0.3-0.1-0.5,0C127.9,83.3,127.8,83.4,127.9,83.6C127.7,83.5,127.8,83.6,127.9,83.6z"
						/>
						<path
							class="st2"
							d="M124.4,80.5c-0.4,0.1-0.6,0.4-0.7,0.7c0,0.1,0,0.2,0.1,0.2l0,0c0.1,0,0.1,0,0.2-0.1c0.1-0.2,0.2-0.3,0.3-0.4
		V81c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5c0-0.1,0-0.2-0.1-0.3c0.1,0,0.2,0,0.3,0.1s0.2,0,0.2,0v-0.2
		C125.4,80.4,124.8,80.4,124.4,80.5z M124.8,81.2c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2
		C124.9,81.1,124.9,81.2,124.8,81.2z"
						/>
						<path
							class="st2"
							d="M128.7,79c-0.5,0.2-0.8,0.5-0.9,0.8c0,0.1,0,0.2,0.1,0.2c0,0,0,0,0.1,0s0.1,0,0.2-0.1c0.1-0.2,0.3-0.4,0.6-0.6
		v0.1c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5c0-0.1,0-0.2-0.1-0.3c0.3,0,0.6,0.1,0.8,0.3c0.1,0,0.2,0,0.2,0c0-0.1,0-0.2,0-0.2
		C129.9,78.9,129.3,78.8,128.7,79z M129.2,79.5c0,0.1-0.1,0.2-0.2,0.2s-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2S129.2,79.4,129.2,79.5z"
						/>
						<path
							class="st2"
							d="M127.3,78.7L127.3,78.7c0.1,0,0.2,0,0.2-0.1c0.3-0.8,1.9-0.9,2.3-0.8c0.1,0,0.2,0,0.2-0.1s0-0.2-0.1-0.2
		c-0.4-0.1-2.2,0-2.6,1C127.2,78.5,127.2,78.6,127.3,78.7z"
						/>
						<path
							class="st2"
							d="M130.4,125.6h0.1c0.1-0.1,0.1-0.2,0-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0.2-0.2,0.3-0.2s0.1,0,0.2,0.1
		c0.1,0.1,0.1,0.1,0.2,0c0.1,0,0.1-0.1,0-0.2c-0.1-0.2-0.3-0.2-0.5-0.2s-0.5,0.2-0.5,0.4c0,0.1-0.1,0.4,0.2,0.6
		C130.3,125.5,130.3,125.6,130.4,125.6z"
						/>
						<path
							class="st2"
							d="M152.9,100.7c-1.2-0.3-3-0.5-3.1-3.1c-0.2-3-2.5-4.2-4.5-5.5c-1.9-1.3-7.2-1.8-8-2.5c0.2,1.3-0.4,2.5-1.1,3.3
		c-0.4-0.1-0.7-0.3-1.1-0.5c0.9-0.9,1.8-2.7,1.9-3.7c-0.1-0.1-0.1-0.2-0.2-0.4c-0.2,0.9-1.2,2.7-2.3,3.7c-0.3-0.2-0.6-0.4-0.9-0.6
		c2-1.6,2.9-4,2.9-4c0-0.3-1.1-1.6-1.4-1.6c0,0-1.1,1.9-2.4,2.5c0-0.1,0-0.1,0-0.1c0.1-0.3,0.2-0.6,0.2-0.9c0.8-0.7,1.9-1.8,2.1-2.4
		c0,0-0.1-0.2-0.1-0.4c0.5,0.6,1.8,2.3,3.3,2.9c1.8,0.8,3.8,0.3,3.8,0.3s-0.2,2.4,1.8,3.2c1.9,0.8,4.4-1.1,5.4-0.9s1.2,0.5,1.6,3.3
		c0-4-1.5-4.2-2.2-4.2s-2.1,1.3-2.9,0.4s-0.3-2.3-0.8-3.1c-0.6-0.8-1.3-1.1-1.3-1.1s-0.2-1.6-1.4-1.7s-2.9-0.4-3.4-1.2
		c1,0.9,2.9,0.4,4.5-0.1s1.9,0.4,2.6,3.5c0.1-1.5-0.1-3.5-1.5-4c-1.5-0.5-2.1-0.2-3.3,0c-0.9,0.1-1.4-0.8-1.6-1.2
		c0,0-0.3,0.2-0.8,0.3c0.5-0.1,1.7-1.1,2.5-0.8c0.7,0.3,1.2,1.3,1.9,1.3s2.2-0.6,2.9-0.5c-0.6-0.6-2.1,0.2-3,0s-0.5-1.9-1.5-2.2
		c-0.9-0.3-1.7,0.4-1.7,0.4s0-0.1,0-0.3v-0.1c-0.1-0.8-0.5-2.4-1.8-2.7c-1.7-0.4-2.8-0.1-2.8-0.1s1.3-3.4,2.7-3.1
		c1.8,0.4-0.4,2.3,1.2,3.2c1.3,0.7,2.7,0,3.5,0.1c0.8,0.2,1.3,1.5,2.2,1.7s2.8-0.5,3.4-1.9c-1.4,0.8-2.8,0.9-3.9,0.3
		s-0.3-1.5-1.2-1.7s-2.2,1.4-3,0.6c-0.7-0.7-0.2-1.2-0.2-1.9c0-0.7-1.6-2.1-2.9-1.3c0.1-0.2,0.5-0.6,1.3-0.5c1,0.1,1.5,1.2,2.1,1.3
		c0.3,0.1,1.9,0.1,2.1-1.3c-0.5,0.5-1.1,1.1-2.1,0.8c-0.9-0.3-0.9-2.5-2.9-2.5s-3.4,2.5-4.5,2.7s-5.4-1-7-0.5s-1.4,2-1.3,2.3
		c0.1,0.2,0.3,0.4,0.4,0.5c0,0,0,0-0.1,0c-0.2,0-0.3,0-0.4,0c-0.1-0.1-0.2-0.3-0.2-0.5c-0.1-0.3-0.2-0.7,0-1.1c-0.1,0-0.3,0-0.5,0
		c-2.7,0.7-2.2,2.5-2.9,3.2l0,0c-0.4,0.2-0.8,0.5-1,0.9c-0.3,0.5-0.1,1.5,0.3,2c-0.3,0.3-0.7,0.6-0.6,1.4c0.2,1.4,1.3,1.2,1.3,1.2
		s-0.2,2.6,0.8,3.5s1.1,0.9,1.1,0.9s-2,0.9-1.2,3.2c0.5,0.2,0.8,0.7,0.9,1.2c0.1,0.6-0.2,1.4-0.7,1.7c-0.8,0.4-1.9,0.1-1.9-0.7
		c0.2,0.7,1.3,0.9,1.8,0.5c0.5-0.3,0.6-0.9,0.5-1.5c-0.1-0.9-2.2-1.9-3.6-0.8c-1.2,0.9-1.2,2.2-0.7,3.3c-1,0.4-2.3,1-3,1.9
		c-0.9,1.1-1.3,2.9-1.7,4.6c-0.3,2.5-0.7,4.4-1.4,6.2c-0.2,0.5-0.3,0.9-0.5,1.4c-0.4,1.2-0.8,2.2-1.1,3.4c-0.4,1.7-0.7,3.7-1,5.3
		l0,0c0,0.1-0.1,1.5,0.1,2.3c0.1,0.2,0.1,0.4,0.2,0.6v0.1c0.2,1,0.6,2.3,1.1,2.8c0.3,0.3,0.8,0.5,1.2,0.5c1,0,1.9-0.7,2.1-0.9
		c0.6-0.3,3.4-1.9,4-2.8c0.1-0.1,0.3-0.3,0.4-0.4c0.1,1.3,0.3,2,0.4,2.7c0.2,0.9,0.3,1.7,0.3,3.6c0,1.2-0.3,2.2-0.7,3.6
		c-0.6,2.3-1.4,5.4-1.7,11.1c-0.5,8.8,0.5,15,2.4,23.3c-0.1,0.3-0.4,0.6-0.6,1v0.1c-0.7,1.2-1.6,2.8-2.1,4.1
		c-1.2,2.3-2.7,6.4-3.2,11.5c-0.4,4-0.7,5.2-1.1,6.8v0.1c-0.1,0.5-0.2,1-0.4,1.7c0,0.8-2.7,5-4.7,7.1c-0.2,0.2-0.6,0.5-0.9,0.7
		c-0.2,0.1-0.3,0.2-0.5,0.4c-0.3,0.4-0.3,0.9-0.3,1.1l0,0c-0.5,0.4-0.5,0.9-0.5,1.2c0,0,0,0,0,0.1c-0.3,0.3-0.7,1-0.2,1.6l0.1,0.1
		c0,0,0,0,0.1,0.1c-0.2,0.5-0.2,1,0.2,1.2c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0.1,0.2,0.3,0.5,0.6c0.2,0.1,0.4,0.1,0.6,0.1
		c0.8,0,1.8-0.8,2-1c0.2-0.1,0.9-0.4,1.7-1.1c0.7-0.6,1-1.2,1.3-2c0.2-0.3,0.3-0.7,0.6-1.1c0.9-1.3,1.6-1.8,2.2-2.3
		c0.5-0.4,0.9-0.7,1.3-1.3c0.4-0.7,0.4-1.7,0.5-2.6c0-0.4,0.1-0.9,0.1-1.1c0.4-1.9,1.1-3.4,2-5.3c0.5-1.1,1.6-3.8,2.2-5.3v-0.1
		c-0.2,1.8-0.3,4.3,0,7.8c0.2,3.4-0.7,5.9-1.3,7.4c-0.2,0.5-0.3,0.9-0.4,1.3c-0.1,0.4-0.1,0.6-0.1,0.9c0,0.2-0.1,0.4-0.1,0.6
		c-0.2,0.7-0.4,1.4,0.2,2.3c0.7,1,1.4,1.1,2.1,1.3c0.2,0.1,0.5,0.1,0.8,0.2c1,0.4,1.5,1.1,2.1,1.9c0.2,0.3,0.4,0.6,0.6,0.9
		c0.3,0.4,0.7,0.6,1,0.8c0.1,0.1,0.2,0.1,0.3,0.2v0.1c0.3,0.5,0.7,1,1.1,1.2c0.6,0.2,1.1,0.4,1.5,0.4c0.6,0,1-0.3,1.2-0.6
		c0.1,0,0.1-0.1,0.2-0.1c0.2,0,0.3-0.1,0.4-0.3c0.3-0.3,0.2-0.7,0.1-1v-0.1c0,0,0,0,0-0.1c0.1-0.1,0.2-0.3,0.3-0.5
		c0.1-0.4-0.1-0.7-0.2-0.9c0-0.1,0-0.3,0-0.3c0-0.5-0.5-0.9-0.7-1.1l0,0l0,0l0,0c0,0,0,0,0-0.1c0-0.2-0.1-0.5-0.2-0.7
		c-0.3-0.3-0.6-0.6-1-0.8c-0.1-0.1-0.2-0.2-0.3-0.2c-0.6-0.4-1-1-1.4-1.5l0,0c-0.2-0.2-0.3-0.4-0.4-0.5c-0.4-0.4-2-3.1-2.2-3.7
		c-0.1-0.4,0.5-1.9,1-3c0.3-0.8,0.7-1.5,0.8-2.1c0.6-2.3,1.4-4.3,2.3-6.6l0.5-1.2c0.5-1.2,0.9-2.9,1.4-4.4c0.5-1.9,1.1-4,1.6-4.6
		c0.9-1.2,1.6-2.9,2.1-5c0.2-0.4,0.6-1,1-1.9c1-1.7,2.6-4.3,4-7.5c0.6,0.9,0.9,1.9,0.5,3c0.8-1.3,0.5-2.5-0.2-3.6
		c0.3-0.7,0.6-1.3,0.9-2c1,0.9,1.1,2.7,1.8,3.8c-0.5-1.8-0.2-3.6-1.4-4.7l0,0c0.2-0.4,0.3-0.9,0.5-1.3c1.7,0.7,1.6,2.1,2.1,3.4
		c-0.3-1.4-0.6-3.2-1.3-3.6c-0.2-0.1-0.4-0.2-0.6-0.3c0.9-2.8,1.7-5.8,2.1-9c0-0.3,0.1-0.8,0.1-1.3l0.1-0.7h0.1
		c0.9-0.6,2.8-2,3.4-2.7c-1,0.3-2.1,1-3.4,0.5c2.7,0,7.2-3.5,8.1-7.4c0.9-3.9-1.3-8.8-2-9.1c-0.3-0.1-0.5-0.3-0.7-0.4
		c1.4,0.5,4.3,0.9,4,8.6c1.6-7.4-0.7-8.8-2.9-10.3c-0.7-0.5-1.6-2.4-1.6-4.9c0-2.1-0.7-6.5-2.4-8.1c1.4,0.7,2.1,2.3,2.1,3.9
		c0.2-0.5,0.3-1,0.3-1.5c-0.1-0.5-0.1-1.4-0.1-2.7c0-1,0.6-1.7,0.9-2.3c0.3-0.8,0.1-2.9,0.1-2.9c0.2,1.2,0.9,0.8,0.7,2.6
		c-0.1,0.9-1,2.4-0.6,3.3c0.3,0.6,1.4,1.2,1.6,1.7c-0.2-0.6-1.5-1.3-1.5-2.3c0.1-0.7,0.8-1.8,0.9-2.9c0.2-2.6-1.9-4-1.9-5.7
		c0.6,1.6,1.5,3.1,3.1,3.3c0.9,0.1,1.5,0.4,1.9,1.5c0.5,1.3,0.7,3.7,2.7,4.2C154.3,106.1,155.4,101.4,152.9,100.7z M122.6,78.3
		c0-2.3,1.3-3.2,2.1-3.5c0.1,0,0.3,0,0.5,0c0.3,0,0.7,0.1,1,0c1-0.3,1.6,0.1,2.2,0.4c0.3,0.2,0.6,0.3,0.9,0.4
		c0.4,0.1,0.6,0.8,0.9,1.4c0.2,0.5,0.4,1,0.6,1.2c0.6,0.4,0.8,1.2,1,2.1c0.1,0.5,0.2,1.1,0.4,1.6c0.3,0.8,0.8,1.2,0.9,1.3
		c0,0.1-0.1,0.4-0.3,0.9v0.1l0,0c-1.7,3-2.9,3.6-3.5,3.6c-1.2,0-2.3-0.9-3.1-1.6l0,0l0,0l0,0c-0.7-0.7-2.4-2.5-2.8-4.6
		C122.6,79.9,122.6,79.3,122.6,78.3z M134.9,164.4c-0.5,0.9-0.9,1.5-1.1,1.9c-0.5,2.1-1.2,3.7-2.1,4.9c-0.5,0.7-1.1,2.7-1.6,4.7
		c-0.4,1.6-0.9,3.2-1.4,4.4l-0.5,1.2c-0.9,2.3-1.7,4.3-2.3,6.6c-0.2,0.5-0.5,1.3-0.8,2c-0.7,1.6-1.2,2.8-1,3.2
		c0.2,0.7,1.8,3.3,2.2,3.8c0.1,0.1,0.2,0.3,0.4,0.5v0.1c0.4,0.5,0.8,1.1,1.5,1.5c0.1,0.1,0.2,0.2,0.3,0.2c0.3,0.2,0.7,0.5,0.9,0.8
		c0.1,0.1,0.1,0.2,0.1,0.3c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.2,0.1s0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		c0.2,0.1,0.3,0.2,0.4,0.3l0,0l0,0l0,0c0.4,0.3,0.6,0.6,0.6,0.8c0,0,0,0,0,0.1l0,0c0,0-0.1,0-0.2-0.1l-0.3-0.2
		c-0.4-0.2-0.7-0.4-0.8-0.5s-0.2-0.1-0.2,0s-0.1,0.2,0,0.2c0.1,0.1,0.5,0.4,0.9,0.6l0.3,0.2c0.1,0,0.1,0.1,0.2,0.1
		c0.1,0,0.1,0,0.1,0.1l0,0c0.1,0.2,0.2,0.4,0.2,0.7c0,0.1-0.1,0.2-0.1,0.3c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.1-0.1-0.1-0.1
		c-0.3-0.3-0.5-0.4-0.7-0.5c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.2,0-0.2,0c-0.1,0.1,0,0.2,0,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		c0.2,0.1,0.3,0.2,0.6,0.4c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.3v0.1v0.1c0.1,0.3,0.1,0.4,0,0.6c-0.2,0.2-0.2,0.2-0.3,0.2
		c0-0.3-0.3-0.5-0.5-0.6c-0.1-0.1-0.3-0.1-0.4-0.3c-0.1,0-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.3-0.2-0.6-0.4-0.8-0.5
		c-0.1-0.1-0.2-0.1-0.3-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.4,0.3c0.2,0.1,0.5,0.3,0.8,0.5
		c0.1,0,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.1,0.4,0.2,0.3,0.5c-0.2,0.3-0.5,0.5-1,0.5
		c-0.4,0-0.8-0.1-1.4-0.3c-0.3-0.1-0.6-0.6-1-1.1l-0.1-0.1l0,0c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.2-0.6-0.4-0.9-0.7
		c-0.2-0.3-0.4-0.6-0.6-0.9c-0.6-0.9-1.1-1.6-2.2-2c-0.3-0.1-0.6-0.2-0.8-0.2c-0.7-0.1-1.3-0.3-1.9-1.1c-0.5-0.7-0.4-1.4-0.2-2
		c0.1-0.2,0.1-0.5,0.1-0.7s0.1-0.5,0.1-0.8c0.1-0.3,0.2-0.7,0.4-1.2c0.6-1.5,1.5-4.1,1.3-7.6c-0.3-4.3-0.1-7.1,0.2-8.8l0,0
		c1.2-3.1,4.6-8.3,4.7-8.4c1.1-1.4,1.2-2.8,1.3-4c0-0.2,0-0.4,0.1-0.6c0.6-1.5,3.9-15.2,3.6-20.6h0.1c0.1,0.1,0.2,0.3,0.3,0.4
		c0.1,0,0.2,0.1,0.2,0c0.1,0,0.1,0,0.3-0.1c-0.1,0.1-0.1,0.2-0.1,0.4s0.2,0.4,0.4,0.5c-0.2,0.9-0.2,2,0.5,2.4
		c0.8,0.5,1.8,0.1,2.7,0.9c1,1-0.5,4.9,1.4,6.4c0.7,0.6,1.5,1.2,2.1,1.9C137.5,160,135.9,162.6,134.9,164.4z M139.2,156.1
		c-0.5-0.7-1.1-1.2-1.7-1.7c-0.9-0.7-0.9-2.7-0.5-4.2c-0.1,1.3,0.5,3.5,2.2,3.7c0.3,0,0.6,0.2,0.9,0.3
		C139.8,154.9,139.5,155.5,139.2,156.1z M140.4,153.3c-1.1-0.7-2.3-0.5-2-3.2l0,0c0.1-1.2,0-3.2-0.5-3.6c-0.6-0.5-2,0-2.2-0.3
		c0.3,0.3,1.8-0.1,2.2,0.1c1,0.6,0.6,2.5,0.8,4c0.1,0.7,0.9,1.5,1.7,1.7c0.1,0,0.2,0.1,0.4,0.1C140.7,152.5,140.5,152.9,140.4,153.3
		z M143.2,141.4c-0.1,0.5-0.1,0.9-0.1,1.3c-0.3,3.1-1.1,6.1-2,8.9c-0.9-0.4-1.7-0.7-1.6-2.4c0.2-2.3,0.5-4.3-0.5-5
		c-0.5-0.4-1.1-0.5-1.5-0.4c0.2-0.6,0.6-1.3,0.8-1.5s0.7-0.9,1.1-1.4c0.5,0.5,1.4,1.5,3.9,0.1L143.2,141.4z M149.8,129.1
		c0.8,2.5-1.9,6.2-5.8,7.4v-0.6C147.7,134.5,149.6,131.4,149.8,129.1z M147,119c0.8,2.9-1.3,12.2-3.3,15.4l0,0
		c-0.3,0.5-2.2,3.8-3.7,4.5c-0.1,0-0.1,0.1-0.1,0.1c0,0.2-0.1,0.7-0.2,0.8c-0.1,0.1-0.3,0.4-0.6,0.8c-0.4,0.5-0.9,1.2-1.1,1.4
		c-0.4,0.4-1,1.9-1.1,2.2c0,0.1-0.3,0.4-0.7,0.7c-0.2,0.2-0.4,0.4-0.5,0.5s-0.2,0.2-0.3,0.3s-0.5,0-0.6-0.1c-0.1,0-0.1-0.1-0.1-0.1
		c0-0.1,0.5-0.5,0.7-0.8c0.2-0.2,0.4-0.4,0.5-0.5s0.2-0.4,0.4-0.8c0.1-0.3,0.3-0.7,0.4-0.9c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.2,0
		c-0.2,0.1-0.9,0.7-1.4,1.3c0,0,0,0-0.1,0.1c-0.4,0.5-0.7,0.8-0.8,0.8c-0.3,0.1-1.6,0.3-1.9,0.3c0,0-0.1,0-0.1-0.1
		c-0.1-0.1-0.1-0.2,0-0.2c0.2-0.1,1.7-0.6,1.7-0.6s0.1,0,0.1-0.1l1.5-1.9c0.1-0.1,0-0.2,0-0.2c-0.1-0.1-0.2-0.1-0.2,0l-2.2,1.8
		c-0.2,0.1-1.2,0.5-1.4,0.5c0,0-0.1-0.2-0.2-0.3c1.2-0.9,3.3-2.6,3.4-2.7c0.1-0.1,0.1-0.2,0-0.2c-0.1-0.1-0.2-0.1-0.2,0l-2.6,2.1
		l0,0l-0.9,0.6l0,0c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.1,0-0.2-0.1l0,0c0.1-0.2,0.5-0.7,0.8-1.1c0.3-0.3,0.5-0.6,0.7-0.8
		c1.7-1.3,3-3.2,3-3.2c0.1-0.1,0.2-0.3,0-0.4c-0.1-0.1-0.2,0-0.4,0.3c-0.1,0.2-0.6,0.6-2,1.1l0,0c-0.2,0.1-0.7,0-0.9-0.2
		c-0.1,0-0.1-0.1-0.1-0.1c0.1-0.2,1.2-1,2.2-1.7c0,0,1.3-1.2,1.8-1.5c0.6-0.4,1.7-0.5,2.7-0.4c0.1,0,0.1,0,0.1-0.1
		c0.9-1.1,2.1-5.6,2.1-8.8l0,0c0,0,0.3-3.2,0.4-4.2c0.1-1.1,0.3-1.9,0.4-2.6c0.2-1,0.3-1.6,0-1.9c-2.3-4.2-3.7-8.7-3.9-9.3
		c0.1-0.9-0.1-2-0.6-3c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.1,0.2c0.5,1,0.7,1.9,0.6,2.7v0.1v0.1c-0.1,0.4-0.2,0.7-0.4,1
		c-0.6,1-1.7,1.6-2.8,1.7c-1.1,0-2.1-0.3-2.8-1s-1.1-1.8-1.1-3c0-0.1-0.1-0.2-0.2-0.2s-0.2,0.1-0.2,0.2c0,1.3,0.4,2.4,1.2,3.2
		c0.7,0.7,1.8,1.1,2.9,1.1h0.1c1.2,0,2.4-0.8,3.1-1.8c0-0.1,0.1-0.2,0.1-0.2c0,2,0.1,6.3,0.4,7.7l0,0c0.9,1.7,2.7,7.9,2.8,9.2l0,0
		c0,1.8-0.4,3.9-0.9,5.7c-4.3-1.7-8.3-0.7-10.9,1.7c-2.4,2.2-2.3,8.1,1.9,9c-0.3,0.3-0.3,0.5-0.2,0.6v0.1c0.1,0.1,0.2,0.3,0.4,0.3
		c0.2,5.3-3,19.1-3.6,20.4c0,0,0,0,0,0.1c0,0.2,0,0.4-0.1,0.7c-0.1,1.2-0.2,2.5-1.2,3.8c0,0.1-3.4,5.1-4.7,8.3c0,0-0.1,0-0.1,0.1
		s-0.2,0.4-0.5,1.2c-0.6,1.6-1.7,4.2-2.2,5.3c-0.9,1.9-1.6,3.4-2,5.3c-0.1,0.3-0.1,0.7-0.1,1.2c-0.1,0.8-0.1,1.8-0.4,2.4
		c-0.3,0.6-0.7,0.9-1.2,1.2c-0.6,0.4-1.3,1-2.2,2.4c-0.2,0.4-0.4,0.8-0.6,1.2c-0.3,0.7-0.6,1.3-1.2,1.9c-0.8,0.7-1.5,1-1.7,1.1l0,0
		c-0.1,0.1-1,1-1.8,1c-0.2,0-0.3,0-0.4-0.1c-0.3-0.2-0.4-0.4-0.4-0.5l0,0l0,0c0-0.1,0-0.3,0.6-0.5h0.1c0.1-0.1,0.7-0.5,0.7-0.6
		c0.1-0.1,0.7-0.4,1.3-0.7c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.1-0.2-0.1c-0.4,0.2-1.3,0.6-1.4,0.7c-0.1,0.1-0.6,0.5-0.7,0.6
		c-0.5,0.2-0.7,0.4-0.8,0.7c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.1-0.2-0.5,0-0.9l0,0l0,0c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.1-0.1,0.1-0.1
		s0,0,0.1-0.1c0.1-0.1,0.6-0.4,1-0.6c0.5-0.3,0.7-0.4,0.7-0.5c0.1-0.1,0-0.2,0-0.2c-0.1-0.1-0.2,0-0.2,0c-0.1,0.1-0.4,0.2-0.6,0.4
		c-0.6,0.3-1,0.5-1.1,0.7c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2l0,0l-0.1-0.1c-0.5-0.5,0.1-1.1,0.2-1.2c0.1,0,0.2-0.1,0.4-0.2
		c0.9-0.5,1.4-0.8,1.5-0.8c0.1-0.1,0.1-0.2,0-0.2c-0.1-0.1-0.2-0.1-0.2,0c-0.1,0.1-1,0.6-1.4,0.8c-0.1,0-0.1,0.1-0.2,0.1
		c0-0.3,0-0.6,0.3-0.8l0.1-0.1c0.4-0.2,0.7-0.4,0.8-0.5c0.1,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.1-0.2-0.1
		c0,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.3,0.2-0.6,0.4c0-0.2,0.1-0.5,0.2-0.7c0.1-0.1,0.3-0.2,0.4-0.3c0.3-0.2,0.6-0.4,0.9-0.7
		c1.8-1.9,4.8-6.3,4.8-7.3c0.1-0.7,0.3-1.2,0.4-1.6v-0.1c0.4-1.6,0.7-2.8,1.1-6.8c0.5-5,2-9.1,3.2-11.4c0.5-1.2,1.4-2.8,2.1-4v-0.1
		c0.3-0.4,0.5-0.8,0.6-1.1v-0.1c-1.9-8.3-2.9-14.5-2.4-23.3c0.2-5.7,1.1-8.8,1.7-11c0.4-1.4,0.7-2.5,0.7-3.7c0-2-0.1-2.7-0.3-3.6
		c-0.1-0.7-0.3-1.5-0.4-2.9c0.6-0.8,2.4-4.1,3.3-6l0.1-0.2c0.4,0.1,0.8,0.1,1.2,0.1c0.9,0,1.8-0.3,2.5-0.8c1-0.7,1.5-1.8,1.6-3.2
		c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.2,0.2c-0.1,1.2-0.6,2.3-1.5,2.9c-0.9,0.7-2.1,0.9-3.3,0.6l1-1.5c0.2-0.4,0.5-0.9,0.8-1.4
		c0.2-0.4,0.5-0.9,0.6-1h0.2c0.9,0,2.4-0.1,3.3-0.5c0.7-0.1,1.3,0.1,1.7,0.2c0.3,0.1,0.5,0.1,0.6,0.1c0.4,0,2-0.3,2.3-0.4
		c0.2-0.1,0.3-0.3,0.2-0.5c0-0.2-0.1-0.4-0.3-0.5c0.5,0.1,1.1,0.1,1.5,0.1s0.6-0.3,0.7-0.6c0-0.3-0.1-0.6-0.4-0.7
		c-0.5-0.1-2.4-0.6-2.6-0.6c-0.1,0-0.4-0.1-0.9-0.1c-0.1,0-0.2,0-0.4,0c0.6,0,0.9,0,1,0c0,0,0,0,0.1,0s0.4,0,0.8,0.1
		c0.8,0.1,1.8,0.2,2.3,0.2s0.7-0.3,0.8-0.7c0-0.3-0.2-0.7-0.6-0.8c-0.7-0.1-3.1-0.5-3.2-0.5c-0.1,0-0.8-0.1-2.5-0.2
		c0.3-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.4-0.2h0.2c0.6-0.1,1.6-0.3,2.3-0.5c0.5-0.2,0.6-0.5,0.6-0.7c0-0.3-0.3-0.5-0.7-0.5
		c-0.3,0-0.8,0-1.3,0.1s-1,0.1-1.4,0.1c0,0,0,0-0.1,0c-0.3,0.1-0.9,0.3-1.6,0.5c0.2-0.1,0.3-0.3,0.3-0.5c0.1-0.4,0.1-0.8-0.2-1.2
		l-0.1-0.1c-0.4,0-1,0.5-1.3,0.8c-0.1,0.1-0.7,0.4-0.9,0.6c-0.3,0.3-1.9,1.1-2.5,1.4c-0.1,0.1-0.3,0.3-0.7,0.9
		c-0.7,1-1.7,2.4-2.6,3.1c-0.3,0.2-1.3,1.7-2.3,3.3c-0.1,0.1-0.1,0.2-0.2,0.2c0-0.1,0-0.1-0.1-0.2c0-0.2-0.1-0.4-0.1-0.6
		c0-0.4,0-0.9,0-1.4c0-0.6,0.1-1.2,0-1.8c0-0.1-0.1-0.1-0.2-0.1l0,0c-0.1,0-0.1,0.1-0.2,0.1c-0.3,2.7-1.4,5.8-1.4,5.9l0,0
		c-0.3,0.2-0.5,0.4-0.8,0.7c-1.5,1.2-3.3,2.6-4.1,3.6c-0.1,0.1,0,0.2,0,0.2c0.1,0.1,0.2,0,0.2,0c0.8-0.9,2.6-2.4,4-3.6
		c0.4-0.3,0.8-0.6,1.1-0.9l1.2-0.9c0.1-0.1,0.3-0.5,0.7-1c0.7-1.1,2-3,2.3-3.2c1-0.8,2-2.2,2.6-3.2c0.3-0.4,0.5-0.8,0.6-0.8
		c0.2-0.1,2.2-1,2.6-1.4c0.1-0.1,0.5-0.4,0.8-0.5c0.5-0.5,0.8-0.7,1-0.7c0.2,0.3,0.2,0.6,0.1,0.8c-0.3,0.7-1.7,1.1-2.4,1.3
		c-0.4,0.1-0.5,0.1-0.6,0.2c0,0.1,0,0.1,0,0.2s0.1,0.1,0.2,0.1l0.3-0.1c0.9-0.3,3.4-1,4.1-1.3c0.4,0,0.9,0,1.4-0.1
		c0.4-0.1,0.9-0.1,1.2-0.1s0.4,0.1,0.4,0.2s-0.1,0.3-0.4,0.3c-0.6,0.2-1.7,0.4-2.2,0.5h-0.3c0,0-0.2,0.1-0.5,0.2
		c-0.5,0.2-1.4,0.6-1.6,0.7c-0.1,0-0.1,0.1-0.1,0.2s0.1,0.1,0.1,0.1h0.3c1.8,0.1,2.8,0.2,2.9,0.2c0.1,0,2.5,0.4,3.2,0.5
		c0.3,0.1,0.4,0.3,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4c-0.5,0-1.5-0.1-2.2-0.2c-0.5-0.1-0.8-0.1-0.9-0.1l0,0c-0.2,0-0.9,0-2.7,0
		c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.2,0.1,0.2c0.5,0.1,1.4,0.2,2.1,0.3c0.4,0.1,0.8,0.1,0.9,0.1c0.2,0.1,2.2,0.5,2.7,0.6
		c0.2,0,0.2,0.3,0.2,0.3c0,0.2-0.1,0.3-0.3,0.3c-0.5,0-1.4-0.1-1.9-0.2s-2.6-0.2-3.6-0.2c-0.1,0-0.1,0.1-0.2,0.1s0,0.2,0.1,0.2
		c0,0,0,0,2.2,0.4c0.5,0.1,0.8,0.1,1.1,0.1c0.2,0,0.4,0,0.5,0c0.2,0,0.3,0.2,0.3,0.3c0,0.1,0,0.1,0,0.1c-0.2,0.1-1.8,0.3-2.2,0.3
		c-0.1,0-0.3-0.1-0.5-0.1c-0.5-0.1-1.1-0.3-1.9-0.2l0,0c-0.8,0.4-2.3,0.5-3.2,0.5h-0.3h-0.1c-0.1,0.1-0.2,0.3-0.7,1.2
		c-0.3,0.5-0.6,1-0.8,1.4l-1.3,2.1c-1,2.1-2.7,5.1-3.3,5.9h-0.1l-0.2,0.2c-0.1,0.1-0.3,0.3-0.4,0.5c-0.7,0.8-3.6,2.5-4,2.7l0,0
		c0,0-0.9,0.8-1.9,0.8c-0.4,0-0.7-0.1-1-0.4c-0.5-0.5-0.8-1.7-1-2.7v-0.1c-0.1-0.3-0.1-0.5-0.2-0.7c-0.2-0.6-0.1-1.6-0.1-2.2
		c0.2-1.6,0.5-3.6,1-5.3c0.3-1.2,0.7-2.2,1.1-3.4c0.2-0.4,0.3-0.9,0.5-1.3c0.7-1.7,1.1-3.7,1.4-6.2c0.3-1.7,0.8-3.4,1.6-4.5
		c0.7-0.9,1.9-1.5,2.9-1.8c0.6,0.9,1.8,1.6,3.2,1.5c1.6-0.2,1.8-0.6,1.8-0.6c2-0.5,3.4,1.1,4.2,2.4c1.3,2,4.6,0.4,5.5,0.8
		c0.9,0.3,1.1,1.7,2.6,2.4c-1.1-1.1-1.1-2.8-2.3-3.3s-2.7,0.6-3.9-0.2c-1.2-0.8-0.6-1.7-1.3-3s-3.2-1.3-3.2-1.3s0.4-1.9,0.1-2.5
		c0-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.2-0.4l0,0c0.1-0.5,0.3-1,0.4-1.3c0.1-0.2,0.1-0.4,0.2-0.6c0.8,0.8,1.9,1.6,3.1,1.6
		c1,0,2.2-1.1,3.5-3.3c0,0.9-0.3,2.1-0.5,3.1c-0.1,0.5-0.3,1.1-0.4,1.6c-0.1,0.8,0.7,1.7,2.4,2.8c0.6,0.4,1.3,0.6,1.9,0.9
		c0.3,0.1,0.5,0.2,0.8,0.3c1.3,0.4,2.6,0.8,3.3,2.4c1.5,3.1,2.1,5.6,2.7,8.3c0.1,0.5,0.3,1.1,0.4,1.7c0.4,1.8,1.6,6.6,2.3,8.6
		C146.4,116.3,147,119,147,119z M118.2,108c0,0.3,0.1,0.5,0.1,0.7s0.1,0.3,0.1,0.5l-0.2,0.3l-0.9,0.7c0.2-0.7,0.6-2,0.9-3.4
		C118.2,107.2,118.2,107.6,118.2,108z M132.5,105.6C132.5,105.6,132.4,105.6,132.5,105.6c-0.3,0-0.7,0-1.1-0.1l0,0
		C131.8,105.6,132.2,105.6,132.5,105.6z"
						/>
					</g>
					<path
						class="st0"
						d="M126.2,60.5c42.9,0,77.8,34.9,77.8,77.8s-34.9,77.8-77.8,77.8s-77.8-34.9-77.8-77.8
	C48.4,95.4,83.3,60.5,126.2,60.5 M126.2,58.6c-44,0-79.6,35.6-79.6,79.6s35.6,79.6,79.6,79.6s79.6-35.6,79.6-79.6
	C205.8,94.3,170.1,58.6,126.2,58.6L126.2,58.6z"
					/>
				</svg>

				<div className="f1 mt-6">{t.title}</div>

				<div className="f3 mt-3">{t.description}</div>

				<div className="f3 mt-3">{t.ticketInfo}</div>

				<button
					type="button"
					className="mt-6"
					onClick={() => navigate("/")}
					style={{
						padding: "14px 28px",
						border: "none",
						borderRadius: "6px",
						backgroundColor: "#0077a8",
						color: "#fff",
						fontSize: "16px",
						fontWeight: 600,
						cursor: "pointer",
					}}
				>
					{t.button}
				</button>
			</div>
		</Page>
	)
}
